<template>
  <div class="wrapper">
    <div class="container">
      <div class="cont-head" :class="{'newStyle':!newStyle}">
        <span>Register a personal account</span>
      </div>
      <div class="pic">
        <img src="../assets/personal.png">
      </div>
      <div class="info">
        <p>Country/Region:<span>{{countryShow}}</span></p>
        <p>Username:<span>{{userName}}</span></p>
      </div>

      <div class="icon-spe2" :class="{ 'in':isH ,'vuerify-invalid':isQ}">
        <el-tooltip :disabled= disC  placement="top" effect="light">
          <div class="tooltip"  slot="content">
            <span>{{$t('errtip3')}}</span>
          </div>
          <input type="text" :placeholder=Veri v-model="vcode" @focus="check56(0)" @blur="check56(1)"  >
        </el-tooltip>
        <div class="time" :class="{'in2':(isH || isQ)}">
          <button @click="sendSeccode" :disabled="canClick"><label>{{send}}</label></button>
        </div>
      </div>

      <div class="icon-bor" :class="{ 'in':isJ ,'vuerify-invalid':isS}">
        <el-tooltip :disabled= disE  placement="top" effect="light">
          <div class="tooltip"  slot="content">
            <span>{{$t('errtip5')}}</span>
          </div>
          <input type="text" :placeholder=fullname v-model="full_name" @focus="check58(0)" @blur="check58(1)" >
        </el-tooltip>
      </div>

      <div class="icon-bor" :class="{ 'in':isK ,'vuerify-invalid':isT}">
        <el-tooltip :disabled= disF  placement="bottom" effect="light">
          <div class="tooltip"  slot="content">
            <p class="longP" :class="{'correct1':ps1}">{{$t('errp1')}}<br>{{$t('errp2')}}</p>
            <p :class="{'correct':ps2}">{{$t('errp3')}}</p>
            <p :class="{'correct':ps3}">{{$t('errp4')}}</p>
            <p :class="{'correct':ps4}">{{$t('errp5')}}</p>
            <p :class="{'correct':ps5}">{{$t('errp6')}}</p>
            <p :class="{'correct':ps6}">{{$t('errp7')}}</p>
          </div>
          <input class="longps" type="password" :placeholder=Enterpas v-model="password" @focus="check59(0)" @blur="check59(1)">
        </el-tooltip>
      </div>


      <div  class="operate"  :class="[ isA ?'Select':'noSelect']">
        <input type="checkbox"  @click="check1()">
        <label>{{$t('agree')}}<span><a href="http://www.medtrum.com/privacy_policy.html">{{$t('privacy')}}</a></span>
          {{$t('and')}}<span><a href="http://www.medtrum.com/terms_of_use.html">{{$t('use')}}</a></span></label>
      </div>
      <div  @click="register">
        <button class="register" :class="{'click':isA}" :disabled="!isA">{{$t('Register')}}</button>
      </div>
    </div><!--container结束-->
  </div>
</template>

<script>
  import auth from '../auth/auth'
import format from '@/lib/format'
  export default {
    data() {
      return {
        email:'',
        mobile:'',
        vcode: '',
        icode:'',
        password:'',
        error: '',
        full_name:'',
        token:'',
        newStyle:false, flag:0,flag1:0,country:"",countryShow:'',invite_token:'',

        send:this.$t('send'),Ema:this.$t('Enter email'),Mob:this.$t('Enter mobile'),userName:'',
        Veri:this.$t('Verification'),invi:this.$t('Invitation'),fullname:this.$t('full name'),Enterpas:this.$t('Enter pass'),
        canClick:false,


        isA:false, isB:true, isC:false, isD:true, isE:false, isF:false,
        isG:false, isH:false, isI:false, isJ:false, isK:false,
        isO:false, isP:false,isQ:false, isR:false,isS:false, isT:false,
        disA:true, disB:true,disC:true, disD:true,disE:true, disF:true, //设置提示

        //密码提示
        ps1:false, ps2:false, ps3:false, ps4:false, ps5:false, ps6:false,
      }
    },
    vuerify: {
      full_name:'realname',
      vcode:'icode',
    },
    computed: {
      errors () {
        return this.$vuerify.$errors
      },
      getLanguage(){
        return this.$store.state.language;
      }
    },
    watch:{
      getLanguage(val){
        this.send = this.$t('send');
        this.Ema = this.$t('Enter email');
        this.Mob =  this.$t('Enter mobile');
        this.Veri = this.$t('Verification');
        this.invi = this.$t('Invitation');
        this.fullname = this.$t('full name');
        this.Enterpas = this.$t('Enter pass');
        if(val==='zh'){
          this.newStyle=true;
        }else{
          this.newStyle=false;
        }
        console.log(this.newStyle);
      }
    },
    methods: {
      //注册
      register() {
        let info = {
          user_type:'P',
          user_name:this.userName ,
          password: this.password,
          real_name:this.full_name,
          country:this.country,
          token:this.token,
          invite_token:this.invite_token,
          seccode:this.vcode,
          ver:2,
        };
        //console.log(info);
        if(this.$vuerify.valid){
          auth.register(this,info);
        }else{
          let err = 'some required is not fill!';
          alert(this.$vuerify.$errors.email||err);
        }
      },
      //发送验证码
      sendSeccode(){
        var para = {
          user_name:this.userName,
          country:this.country,
          flag: 'email' ,
          purpose:'regist',
        };
        if(para.user_name===""){
          alert('email  is required!');
        }else{
          auth.sendSeccode(this,para);
          auth.setTime(this);
        }
      },

      //密码验证
      checkPassword(){
        let password = this.password.trim();
        if(password.length>5 && password.length<21){ this.ps2 =true; }else{ this.ps2 =false; }
        if(password.length>0) {
            if(password.indexOf(' ')===-1){ this.ps6 =true; }else{ this.ps6 =false; }
            if(password===this.full_name){ this.ps3 =false; }else{ this.ps3 =true; }
            let p1=/[a-z]/.test(password),p2=/[A-Z]/.test(password),p3=/[0-9]/.test(password),p4=/[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),count=0;
            if(p1){count++;}
            if(p2){count++;}
            if(p3){count++;}
            if(p4){count++;}
            if(count>2){
                this.ps1 =true;
            }else{ this.ps1 =false; }

            for(let i =0;i<password.length-2;i++){
               if(password[i+1]-password[i]===1&&password[i+2]-password[i+1]===1){
                 this.flag = 1;break;
               }else{
                   this.flag = 0;
               }
              if(password[i]-password[i+1]===1&&password[i+1]-password[i+2]===1){
                this.flag = 1;break;
              }else{
                this.flag = 0;
              }
            }
            if(this.flag===0){ this.ps4 =true; }else{ this.ps4 =false; }

          for(let i =0;i<password.length-2;i++){
              if(password[i+1].charCodeAt()-password[i].charCodeAt()===1 && password[i+2].charCodeAt()-password[i+1].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
            if(password[i].charCodeAt()-password[i+1].charCodeAt()===1 && password[i+1].charCodeAt()-password[i+2].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
          }
            if(this.flag1===0){ this.ps5 =true; }else{ this.ps5 =false; }
        }
        console.log()
        if(this.ps1===true && this.ps2===true && this.ps3===true && this.ps4===true && this.ps5===true && this.ps6===true){
          this.isT = false;
          this.disF = true;
        }else{
          this.isT = true;
          this.disF = false;
        }
      },

      check1:function(){
        this.isA = !this.isA;
      },
      check2:function(){
        this.isB = !this.isB;
        this.isC = !this.isC;
      },
      check3:function(){
        this.isD = !this.isD;
        this.isE = !this.isE;
      },

      check56(flag){
        this.isH = !this.isH;
        if(this.Veri === ''){
          this.Veri = this.$t('Verification');
        }else{
          this.Veri = '';
        }
        if(flag===1){
          if (this.$vuerify.$errors.vcode || this.vcode === '') {
            this.isQ = true;
            this.disC = false;
          }else{
            this.isQ = false;
            this.disC = true;
          }
        }
      },
      check58(flag){
        this.isJ = !this.isJ;
        if(this.fullname === ''){
          this.fullname = this.$t('full name');
        }else{
          this.fullname = '';
        }
        if(flag===1) {
          if (this.$vuerify.$errors.full_name || this.full_name === '') {
            this.isS = true;
            this.disE = false;
          } else {
            this.isS = false;
            this.disE = true;
          }
        }
      },
      check59(flag){
        this.isK = !this.isK;
        if(this.Enterpas === ''){
          this.Enterpas = this.$t('Enter pass');
        }else{
          this.Enterpas = '';
        }
        if(flag===1) {
          this.checkPassword();
        }
      },
    },
    mounted(){
      let url = location.href;
      if(url.indexOf('?')!==-1){
        let str = url.substr(1);
        this.invite_token = str.split('=')[1];
        let param ={
          token: this.invite_token
        };
        this.$http.post('api/v2.0/invite/validate',param).then(function(res){
          let err =res.data.error;
          if(err===0){
            this.userName = res.data.email;
            this.country = res.data.country;
            this.countryShow = (this.country)?this.$t(this.country):"";
          }else{
              let tip ='Incorrect verification';
              alert(tip);
              this.$router.push('/');
          }
        });
      }else{
          this.$router.push('/');
      }
    },
  }
</script>

<style scoped>
  .wrapper{
    width:400px;
    height:652px;
    margin: 0 auto;
  }
  .container{
    height:610px;
    padding-top: 30px;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
  }
  .cont-head{
    height:35px;
    width:320px;
    margin:0 auto 34px;
    font-family:SFUIText-Medium;
    font-size:26px;
    color:#323232;
    letter-spacing:-0.63px;
    line-height:35px;
    text-align:center;
  }
  .pic{
    width:80px;
    height: 80px;
    margin:0 auto 35px;
  }
  .info{
    width:300px;
    margin:0 auto;
  }
  .info p{
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#323232;
    letter-spacing:-0.49px;
    line-height:21px;
    text-align:left;
    margin-bottom: 15px;
  }
  .info span{
    color:#22a7dc;
    margin-left: 4px;
    font-size:17px;
  }

  .icon-bor,.icon-spe1,.icon-spe2{
    opacity:0.79;
    background:#ffffff;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    font-family: SFUIText-Regular;
    border-radius:100px;
    width:320px;
    height:46px;
    margin:0 auto 20px;
  }
  .icon-spe2{
    margin-top: 20px;
  }
  .icon-bor input,.icon-spe2 input{
    height:26px;
    width:190px;
    line-height: 30px;
    font-size:20px;
    font-family: SFUIText-Regular;
    letter-spacing:-0.69px;
    text-align:left;
    border: none;
    margin-top: 8px;
    margin-left:22px;
    color: #d2d2d2;
  }
  .icon-bor input:focus,.icon-spe1 input:focus,.icon-spe2 input:focus{
    color: #2aace0;
    border: none;
    outline:none;
  }
  .mobile-choose{
    opacity:0.9;
    width:85px;
    height:45px;
    float: left;
    margin-left:-5px;
    border-right:1px solid #ccc;
  }
  .mobile-choose select{
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#323232;
    letter-spacing:-0.66px;
    text-align:left;
    height:26px;
    margin: 11px 0 11px 20px;
    border:none;
    outline: none;
  }
  .icon-spe1 input{
    width:185px;
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#d2d2d2;
    letter-spacing:-0.49px;
    text-align:left;
    display: block;
    float: left;
    margin:10px 0 11px 10px;
    border:none;
  }
  .time{
    opacity:0.8;
    background:#009fdf;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    width:80px;
    height:46px;
    float:right;
    margin-left:10px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    cursor: pointer;
  }
  .time button{
    background: transparent;
    border:none;
    outline: none;
  }
  .time label{
    display: block;
    font-family: SFUIText-Regular;
    font-size:20px;
    width:44px;
    height:24px;
    margin-left:16px;
    color:#f6f9fa;
    margin-top:10px;
    letter-spacing:-0.49px;
    text-align:center;
    cursor: pointer;
  }
  /*为了解决输入时元素加边框带来的位置移动的问题，改变属性抵消变化*/
  .in{
    /*抵消元素的大小变化*/
    border:1px solid #009fdf;
    height:44px;
    width:318px;
  }
  .in1{
    /*抵消内部元素的位置移动*/
    margin-left:-6px;
    margin-top:-1px;
  }
  .in2{
    margin-right:-1px;
    margin-top:-1px;
  }

  /*表单验证提示框*/
  .tooltip span,  .tooltip p{
    font-family:SFUIText-Regular;
    font-size:15px;
    letter-spacing:-0.37px;
    text-align: left;
    color:#3b3b3b
  }
  .operate{
    width:290px;
    height:32px;
    margin:20px auto 22px;
  }
  .operate input{
    width:16px;
    height:32px;
    filter:alpha(opacity=0);
    opacity: 0;
    float:left;
  }
  .Select{
    background: url("../assets/Select.png") left center no-repeat;
  }
  .noSelect{
    background: url("../assets/No Select.png") left center no-repeat;
  }
  .operate label{
    font-family: SFUIText-Regular;
    font-size:14px;
    color:#5a5a5a;
    letter-spacing:-0.34px;
    text-align:left;
    display: block;
    width:262px;
    margin-left:25px;
    padding-top:7px;
  }
  .operate a{
    text-decoration: none;
    color:#009fdf;
  }
  .operate a:hover{
    opacity:0.6;
  }
  .tooltip p{
    background: url('../assets/no.png') left center no-repeat;
    padding-left: 22px;
    margin-bottom: 2px;
  }
  .tooltip .longP{
    background: url('../assets/no.png') left 1px no-repeat;
  }
  .tooltip .correct{
    background: url('../assets/yes.png') left center no-repeat;
  }
  .tooltip .correct1{
    background: url('../assets/yes.png') left 1px no-repeat;
  }
  /*使提示框居中，加大输入框的长度，offset不起作用的解决措施*/
  .icon-bor .longps{
    width:260px;
  }

  .register {
    height: 45px;
    line-height: 45px;
    width: 324px;
    margin: 0 38px;
    font-family: SFUIText-Regular;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    opacity:0.3;
    cursor: pointer;
    outline: none;
    border:none;
  }
  .click:hover{
    opacity:0.6;
  }
  .click{
    opacity: 0.8;
  }
  .vuerify-invalid{
    border: 1px solid #ff5252;
    height:44px;
    width:318px;
  }
  .icon-bor span,.icon-spe2 span{
    height:12px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left: 30px;
    margin-top:13px;
  }
  .icon-spe1 span{
    height:12px;
    width:140px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left:30px;
    margin-top:47px;
  }
  @media screen and (max-width: 1500px){
    .wrapper{
      height:592px;
    }
    .container{
      height:570px;
      padding-top: 20px;
    }
    .cont-head{
      margin:0 auto 20px;
    }
    .pic{
      margin:0 auto 20px;
    }

  }
</style>



// WEBPACK FOOTER //
// personalApply.vue?766baf18